// Configuration variables that are public and remain the same between environments are stored here
// all other configuration variables are environment variables in /.envrc (or look at /.envrc.example initially)

export const ALGOLIA_APP_ID = "BN78AKZAPO";

const algoliaIndexPrefix =
  typeof process !== "undefined"
    ? process.env.ALGOLIA_INDEX_PREFIX
    : ((window as any).GLOBALS?.ALGOLIA_INDEX_PREFIX ?? "");

export const ALGOLIA_INDICES = {
  insights: `${algoliaIndexPrefix}insights`,
  insightsDateDesc: `${algoliaIndexPrefix}insights_date_desc`,
  insightsSuggestions: `${algoliaIndexPrefix}insights_query_suggestions`,
  experts: `${algoliaIndexPrefix}experts`,
  pages: `${algoliaIndexPrefix}pages`,
  allDateDesc: `${algoliaIndexPrefix}all_date_desc`,
  all: `${algoliaIndexPrefix}all`,
} as const;

export type AlgoliaIndexName =
  (typeof ALGOLIA_INDICES)[keyof typeof ALGOLIA_INDICES];

export const ALGOLIA_FACETS = {
  insights: {
    topic: "topic.title",
    region: "regions",
    year: "year",
    type: "type",
  },
} as const;

export type AlgoliaInsightFacet =
  (typeof ALGOLIA_FACETS)["insights"][keyof (typeof ALGOLIA_FACETS)["insights"]];

export const ALGOLIA_SEARCH_KEY = "9817fe136bf92104cb683aaea4e43dba";

export const GLOBAL_CACHE_SECONDS = 300;

export function getEnv(property: string): string;

export function getEnv<T>(
  property: string,
  options: { default: T },
): string | T;
export function getEnv(
  property: string,
  options?: { default: string | null },
): string | null {
  const value = process.env[property];
  if (!value && options) return options.default;
  if (!value)
    throw new Error(
      `no environment variable found for "${property}" and no default provided`,
    );
  return value;
}

export const RECAPTCHA_SITE_KEY =
  typeof process !== "undefined"
    ? process.env.RECAPTCHA_SITE_KEY
    : ((window as any).GLOBALS?.RECAPTCHA_SITE_KEY ?? "");

export const RECAPTCHA_ACTION = "submit_contact_form";

export const INSIGHT_CARD_GROUP_SIZE = 12;

export const SALESFORCE_HOST_SCRIPT_SRC =
  "https://instituteglobal.my.site.com/lp/assets/scripts/external-forms-host.min.js";
